import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { CalendarItem } from 'src/app/core/models/client-models';

export type CalendarItemsState = EntityState<CalendarItem, number>;

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'calendarItem' })
export class CalendarItemsStore extends EntityStore<CalendarItemsState> {
  constructor() {
    super();
  }
}
